export const BREAKPOINTS = {
    largeMobileBreakpoint: '29.5em', 	// <472px
    smallTabletBreakpoint: '36.5em', 	// <592px
    tabletBreakpoint: '47.5em',		    // <768px
    desktopBreakpoint: '63em',		    // <1024px
    widescreenBreakpoint: '80em',		// <1280px
    superWideBreakpoint: '112.5em',     // 1800px
};

export const COLORS = {
    siteLighterGrey: '#f4f4f4',
    siteLightGrey: '#ebebeb',
    siteDarkGrey: '#222528',
    siteLighterBlue: '#9ECEF3',
    siteLightBlue: '#b0b8bf',
    siteMidBlue: '#374652',
    siteBlue: '#516a7d',
    siteDarkBlue: '#1e3d55',
    siteTabBlue: '#8DAEC3'
};

export const MODAL_STYLE_RESET = {
    overlay: {
        position: null,
        top: null,
        left: null,
        right: null,
        bottom: null,
        backgroundColor: null
    },
    content: {
        position: null,
        top: null,
        left: null,
        right: null,
        bottom: null,
        border: null,
        background: null,
        overflow: null,
        WebkitOverflowScrolling: null,
        borderRadius: null,
        outline: null,
        padding: null

    }
};

export const MODALS = {
    ASSIGNMENT_ARCHIVE_CONFIRM: 'assignmentArchiveConfirm',
    ASSIGNMENT_CLONE_CONFIRM: 'assignmentCloneConfirm',
    ASSIGNMENT_CONTENT_LIST: 'assignmentContentList',
    ASSIGNMENT_CONTENT_REMOVE_CONFIRM: 'assignmentContentRemoveConfirm',
    ASSIGNMENT_CONTENT_REVIEW: 'assignmentContentReview',
    ASSIGNMENT_CONTENT_SELECTION: 'assignmentContentSelection',
    ASSIGNMENT_DELETE_CONFIRM: 'assignmentDeleteConfirm',
    ASSIGNMENT_DETAILS: 'assignmentDetails',
    ASSIGNMENT_EDIT: 'assignmentEdit',
    ASSIGNMENT_EDIT_ADVANCED: 'assignmentEditAdvanced',
    ASSIGNMENT_PINPOINTS_LIST: 'assignmentPinpointsList',
    ASSIGNMENT_PINPOINTS_REVIEW: 'assignmentPinpointsReview',
    ASSIGNMENT_PINPOINTS_SELECTION: 'assignmentPinpointsSelection',
    ASSIGNMENT_USERS_LIST: 'assignmentUsersList',
    ASSIGNMENT_USERS_REVIEW: 'assignmentUsersReview',
    ASSIGNMENT_USERS_SELECTION: 'assignmentUsersSelection',
    CONTENT_DELETE_CONFIRM: 'contentDeleteConfirm',
    CONTENT_DETAILS: 'contentDetails',
    CONTENT_EDIT_CHECKLIST: 'contentEditChecklist',
    CONTENT_EDIT_CHECKLIST_ADD_ITEM: 'contentEditChecklistAddItem',
    CONTENT_EDIT_FILE_UPLOAD: 'contentEditFileUpload',
    CONTENT_SELECT_EDIT: 'contentSelectEdit',
    GROUP_DELETE_CONFIRM: 'groupDeleteConfirm',
    GROUP_DETAILS: 'groupDetails',
    GROUP_EDIT: 'groupEdit',
    PINPOINT_DELETE_CONFIRM: 'pinpointDeleteConfirm',
    PINPOINT_DETAILS_BEACON: 'pinpointDetailsBeacon',
    PINPOINT_DETAILS_GPS: 'pinpointDetailsGPS',
    PINPOINT_EDIT: 'pinpointEdit',
    USER_DETAILS: 'userDetails',
    USER_DELETE_CONFIRM: 'userDeleteConfirm',
    USER_EDIT: 'userEdit',
    USER_GROUP_REMOVE_CONFIRM: 'userGroupRemoveConfirm',
    USER_GROUP_REVIEW: 'userGroupReview',
    USER_GROUP_SELECTION: 'userGroupSelection',
    USER_IMPORT: 'userImport'
};

export const FILE_TYPES = {
    'image/jpeg': 'Image',
    'image/png': 'Image',
    'image/gif': 'GIF',
    'video/mp4': 'Video',
    'video/quicktime': 'Video',
    'application/msword': 'Word',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'Word',
    'application/vnd.ms-powerpoint': 'PowerPoint',
    'application/x-mspowerpoint': 'PowerPoint',
    'application/powerpoint': 'PowerPoint',
    'application/mspowerpoint': 'PowerPoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'PowerPoint',
    'application/pdf': 'PDF'
};

export const FILE_UPLOAD_LOCATIONS = {
    UPLOAD: 'upload',
    THUMBNAIL: 'thumbnail'
};

export const USER_ROLES = {
    ADMIN: 'admin',
    CREATOR_ADMIN: 'creator_admin',
    CREATOR_SEARCH_INBOX: 'creator_search_inbox',
    CREATOR_INBOX: 'creator_inbox',
    SEARCH_INBOX: 'search_inbox',
    INBOX_ONLY: 'inbox_only',
    DEITY: 'deity'
};

export const USER_ROLES_LOOKUP = {
    'admin': 'Account Administrator',
    'creator_admin': 'Administrator',
    'creator_inbox': 'Inbox & Create',
    'creator_search_inbox': 'Inbox, Create, & Library',
    'inbox_only': 'Inbox',
    'search_inbox': 'Inbox & Library'
};

export const CHECKLIST_ITEM_TYPES_LOOKUP = {
    'yes_no': 'Yes / No / N/A',
    'safe_notsafe': 'Safe / Not Safe / N/A'
};



// WEBPACK FOOTER //
// ./src/utils/constants.js